<template>
    <div id="combo-select">
        <b-form-group
            :label="data.label"
            label-class="text-left"
            >
            <b-form-select 
                v-model="data_value" 
                :value="data_value"
                :options="options"
                @input="inputChange"
                text-field="text"
                value-field="value"
            ></b-form-select>
        </b-form-group>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default Vue.extend({
        name: 'ComboSelect',
        props: {
            data: { 
                type: Object, 
                    default: () => ({
                        default_value: null,
                        label: null,
                        options: []
                    }),
                    required: true 
            },
        },
        data() {
            return {
                options: [],
                data_value: this.data.default_value
            }
        },
        methods: {
            inputChange(value) {
                this.$emit('selected', value)
            }
        },
        created () {
            this.data_value= this.data.default_value
            this.options= this.data.options
        },
    })
</script>

<style lang="scss" scoped>

</style>